import React from "react";
import Navbar from "../../components/common/navbar/Navbar";
import NewExecutive from "../../components/executive/NewExecutive";
import { useLocation } from "react-router-dom";

const NewExecutivePage = () => {
    const { state } = useLocation();
    return (
        <>
            <section className="bajaj_main_block">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12 p-0">
                            {state?.id ? (
                                <Navbar content="EDIT EXECUTIVE" />
                            ) : (
                                <Navbar content="NEW EXECUTIVE" />
                            )}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12 p-0">
                            <NewExecutive />
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default NewExecutivePage;
